import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackSiteEvent } from '@/lib/siteMetrics.js';

const SiteMetrics = () => {
  const location = useLocation();

  useEffect(() => {
    const match = location.pathname.match(/^\/jobs\/([a-zA-Z0-9_-]+)$/);
    trackSiteEvent('page_view', {
      pagePath: location.pathname,
      jobId: match?.[1] || '',
    });
  }, [location.pathname]);

  return null;
};

export default SiteMetrics;
